namespace SorAraBul.Web.Modules.PropertyManagement.FormWizard {
    export interface ChangeFormRequest extends Serenity.ServiceRequest {
        GId?: string;
    }
}
